const linkedDropdownGroupIds = Object.freeze({
  PGE_PLUS_LINKED_DROPDOWN_GROUP_VEHICLE_OPTIONS: '5tCeZqPSyUFEXrowgbq67g',
});

export default linkedDropdownGroupIds;
